import { observer } from 'mobx-react'
import { useEffect, useRef, useState } from 'react'
import ContentState from '../../../../stores/ContentState'
import "./index.scss"
const Shop = observer(() => {
  const content = ContentState
  const inside = useRef<boolean>(false)
  const ref = useRef<any>(Array())
  const shops = content.about?.shop || []
  const [width, setWidth] = useState(window.innerWidth)

  useEffect(() => {
    setWidth(window.innerWidth)
    window.addEventListener('resize', () => setWidth(window.innerWidth))
  }, [])

  const changeClass = (el: Element) => {
    if (el.classList.contains('show')) {
      el.classList.remove('show')
      el.classList.add('hide')
      return
    }

    if (el.classList.contains('hide')) {
      el.classList.remove('hide')
      el.classList.add('show')
      return
    }
  }

  useEffect(() => {
    let i = 0

    if (!ContentState.about?.shop) return

    const items = document.querySelectorAll('.for-you__shop-item')
    if (!items) return

    const interval = setInterval(() => {
      if (i == items.length) {
        i = 0
      }

      if (items.length) {
        const imgs = items[i].querySelectorAll('img')

        changeClass(imgs[0])
        changeClass(imgs[1])
      }
      i++
    }, 1500)

    return () => {
      clearInterval(interval)
    }
  }, [ContentState.about?.shop])

  return (
    <div className="for-you__shop">
      <div style={{ overflow: 'hidden' }}>
        {width > 900 && (
          <div className="for-you__shop-list">
            {shops.slice(0, 5).map((s: any, i: number) => (
              <div className="for-you__shop-item" key={i}>
                <div className="for-you__shop-wrapper">
                  <img src={s} className="show" />
                  {(shops.length - 1) / 2 == i ? (
                    <img src={shops[shops.length - 1]} className="hide" />
                  ) : (
                    <img src={shops[shops.length - 1 - i]} className="hide" />
                  )}
                </div>
              </div>
            ))}
          </div>
        )}

        {width <= 900 && (
          <div className="for-you__shop-list">
            {shops.slice(0, 3).map((s: any, i: number) => (
              <div className="for-you__shop-item" key={i}>
                <div className="for-you__shop-wrapper">
                  <img src={s} className="show" />
                  <img src={shops[shops.length - 1 - i]} className="hide" />
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
})
export default Shop
